import { useStore } from '../../store/useStore';
import { isExecutive } from '../../utils/auth';

export const useAdminAccess = () => {
  const { currentUser } = useStore();

  return {
    hasAccess: currentUser && isExecutive(currentUser.role),
    isLoading: false,
    currentUser
  };
};